import { render } from "./RetributionsGrid.vue?vue&type=template&id=2a295dec"
import script from "./RetributionsGrid.vue?vue&type=script&lang=js"
export * from "./RetributionsGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__